import {  POST } from "../../helper/xbi4RestFunctions";
export const createProjects = async (org_id: any, data: any) => {
  const path = `/orgs/${org_id}/projects`;
  return await POST(path, data)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
